module.exports = __webpack_public_path__ + "img/HA2510-150.ffe63c48.jpg";